// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

/**
 * This state is for to define auth reducer state varibles.
 * For define auth reducer state purpose.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) initially define
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) user state added
 */

// -------------------------------
//  Auth State
// -------------------------------
export interface AuthState extends EntityState<any> {
  common?: any;
  user?: any;
  permissions?: any;

}

// -------------------------------
//  Auth Adapter
// -------------------------------
export const authAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  Auth Initial State
// -------------------------------
export const initialState: AuthState = authAdapter.getInitialState(
  {
    common: null,
    user: null,
    permissions: null,
  },
);
